module.exports = __webpack_public_path__ + "img/guide-vip.03f695af.png";